import React, {useState} from 'react';
import './navbar.css';
import {Link} from 'react-router-dom';
import {FaBars, FaTimes} from 'react-icons/fa';
import ciscoLogo from '../assets/partnerlogo.svg';


const Navbar = () => {
    const[click, setClick] = useState(false)
    const handleClick = () => setClick(!click)

  return (
    <div>
    <div className='header'>
        <Link to='/'><h1>BIO-<span className='h1color'>ZEIT</span></h1></Link>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li>
                <Link to='/'>Home</Link>
            </li>
            <li>
                <Link to='/services'>Services</Link>
            </li>
            <li>
                <Link to='/contact'>Contact</Link>
            </li>
        </ul>
        <div className='hamburger' onClick={handleClick}>
            {click ? (<FaTimes size={20} style={{color: '#F3FFC6'}}/>) : (<FaBars size={20} style={{color: '#F3FFC6'}}/>)}         
        </div>
    </div>
    <div className='logo'>
        <img src={ciscoLogo} style={{ height: '160px', marginTop: '2.5%'}} alt="Cisco Partner" />
    </div>
    </div>
  )
}

export default Navbar